module.exports = __webpack_public_path__ + "media/slots_classic_fruits_ambience.3623e057.mp3";